<gc-floating-popup-window [popup]="popup()">
  <div floating-popup-header class="pt-4 px-5 pb-3 flex items-center justify-between gap-1">
    <div class="flex-1 min-w-0 flex items-center">
      <span class="text-[0.875rem] font-semibold leading-[150%] tracking-normal truncate min-w-0">{{ popup().title | async }}</span>

      @if (popup().titleInfo | async; as titleInfo) {
        <div class="self-center mx-[0.5rem] h-[0.75rem] min-w-[1px] w-[1px] bg-(--p-primary-100) shrink-0"></div>
        <span class="self-center text-[0.6875rem] font-[500] leading-[150%] tracking-normal shrink-0 whitespace-nowrap">{{ titleInfo }}</span>
      }
    </div>

    <gc-floating-popup-header-actions class="flex items-center gap-1 flex-shrink-0" [popup]="popup()" />
  </div>

  <div floating-popup-body class="h-full w-full">
    <ng-container *ngComponentOutlet="popup().component; inputs: { popup: popup() }; injector: popup().injector"></ng-container>
  </div>
</gc-floating-popup-window>